module.exports = __webpack_public_path__ + "img/Kraftfahrzeug_geländegängig.f556e7f7.svg";